module.exports = __webpack_public_path__ + "img/tool-checklist.495ab086.svg";